/** Shared responsive layout breakpoints. */
export const layout = {
  /**
   * At or below this width the sidenav is a dismissible overlay drawer (phones,
   * heavily zoomed/scaled screens); above it, a persistent icon rail.
   * Mirrors the Food Distribution client so the suite behaves consistently.
   */
  mobileBreakpoint: '(max-width: 768px)',

  /**
   * At or below this width the toolbar drops its text labels (brand name, profile
   * label) and keeps icons only, so the app switcher always has room.
   */
  compactBreakpoint: '(max-width: 600px)',
};

/**
 * Deep links into Identity, the suite's auth/IAM authority. Identity owns profile for every
 * app, so Checkins links out rather than growing its own account screen.
 *
 * These paths are hardcoded by necessity: neither `/api/me` nor `/connect/userinfo` returns a
 * profile URL, so there's no discovery mechanism. If Identity renames a route, update it here.
 */
export const identityPaths = {
  /** Identity's "My account" Razor page (`@page "/account"`): display name + change password. */
  account: '/account',
};
